import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  width: 100%;
  height: 100%;
`;

export const ScrimWrapper = styled.div`
  position: absolute;
  inset-inline: 0;
  inset-block-end: 0;
  height: 65px;
  z-index: 2;
  pointer-events: none;
`;

export const ButtonIconWrapper = styled.div`
  position: absolute;
  top: 1rem;
  right: 1rem;
  z-index: 2;
`;

export const LogoWrapper = styled.div`
  position: absolute;
  bottom: 1rem;
  left: 1rem;
  z-index: 2;
`;

export const TagWrapper = styled.div`
  position: absolute;
  top: 1rem;
  left: 1rem;
  z-index: 2;
`;
